import { useState, useEffect } from "react";
import apiClient from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

// Module-level cache — one network request, shared across all callers
let _cache = null;
let _inflight = null;

export const fetchDepartmentListAction = async () => {
    if (_cache) return _cache;
    if (_inflight) return _inflight;

    _inflight = apiClient.get(ATP_API_URL.DEPARTMENT_LIST)
        .then(response => {
            if (response.status === 200 && Array.isArray(response.data)) {
                _cache = { success: true, departments: response.data };
            } else {
                _cache = { success: false, departments: [] };
            }
            _inflight = null;
            return _cache;
        })
        .catch(error => {
            _inflight = null;
            return { success: false, departments: [], error: error.message };
        });

    return _inflight;
};

export const clearDepartmentCache = () => {
    _cache = null;
    _inflight = null;
};

// Shared hook — use this in both create form and edit modal.
// Returns dropdown-ready options. Reads from cache so only 1 network call ever fires.
export const useDepartmentOptions = () => {
    const [options, setOptions] = useState(
        // Seed from cache immediately if already available
        _cache?.success
            ? [{ value: "", label: "Select department function" },
            ..._cache.departments.map(d => ({ value: String(d.id), label: d.name }))]
            : [{ value: "", label: "Select department function" }]
    );

    useEffect(() => {
        // Already seeded from cache — nothing to do
        if (_cache?.success) return;

        let mounted = true;
        fetchDepartmentListAction().then(result => {
            if (!mounted || !result.success) return;
            setOptions([
                { value: "", label: "Select department function" },
                ...result.departments.map(d => ({ value: String(d.id), label: d.name })),
            ]);
        });
        return () => { mounted = false; };
    }, []);

    return options;
};
